import { render, staticRenderFns } from "./OpenAffiliatesExportModal.vue?vue&type=template&id=f06cbdbe&scoped=true"
import script from "./OpenAffiliatesExportModal.vue?vue&type=script&lang=js"
export * from "./OpenAffiliatesExportModal.vue?vue&type=script&lang=js"
import style0 from "./OpenAffiliatesExportModal.vue?vue&type=style&index=0&id=f06cbdbe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f06cbdbe",
  null
  
)

export default component.exports